export default "__VITE_ASSET__d74e9b2a__"